module.exports = __webpack_public_path__ + "media/arctic-assault.0af9555d.mp3";